<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';

// Destaque azul com Dica em carrossel (5 s). Com movimento reduzido, fica na
// primeira dica e os pontos trocam no clique.
const props = defineProps({
  title: { type: String, required: true },
  tips: { type: Array, required: true },
  icon: { type: String, default: 'i-ph-lightbulb-duotone' },
});

const { t } = useI18n();
const current = ref(0);
let timer = null;

const reducedMotion = () =>
  window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

onMounted(() => {
  if (props.tips.length < 2 || reducedMotion()) return;
  timer = setInterval(() => {
    current.value = (current.value + 1) % props.tips.length;
  }, 5000);
});
onBeforeUnmount(() => clearInterval(timer));
</script>

<template>
  <section
    class="rounded-[1.25rem] p-5 text-white bg-[linear-gradient(180deg,#1A6DF5,#0147E7)]"
  >
    <div class="flex items-center gap-2.5 mb-3.5 font-medium">
      <Icon :icon="icon" class="size-5 flex-none" />
      {{ title }}
    </div>
    <div class="bg-n-card text-n-slate-12 rounded-2xl p-4">
      <div class="grid min-h-[5.75rem]">
        <p
          v-for="(tip, index) in tips"
          :key="index"
          class="[grid-area:1/1] transition duration-200 ease-[cubic-bezier(.4,0,.2,1)] motion-reduce:transition-none"
          :class="
            index === current
              ? 'opacity-100 translate-y-0'
              : 'opacity-0 translate-y-1.5 pointer-events-none'
          "
          :aria-hidden="index !== current"
        >
          <span class="block text-[0.8125rem] text-n-slate-10 mb-1">
            {{ t('ONBOARDING_VISOR.TIP') }}
          </span>
          {{ tip }}
        </p>
      </div>
    </div>
    <div v-if="tips.length > 1" class="flex gap-1.5 mt-3.5">
      <button
        v-for="(_, index) in tips"
        :key="index"
        type="button"
        class="h-1.5 rounded-full transition-all duration-200 ease-[cubic-bezier(.4,0,.2,1)] motion-reduce:transition-none"
        :class="index === current ? 'w-[1.125rem] bg-white' : 'w-1.5 bg-white/45'"
        :aria-label="t('ONBOARDING_VISOR.TIP_N', { n: index + 1 })"
        @click="current = index"
      />
    </div>
  </section>
</template>
